import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, className = "", y = 28 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "", immediate = false }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "0px 0px -8% 0px" });
    const show = immediate || inView;
    return (
        <span ref={ref} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
            <motion.span
                className={`block will-change-transform ${className}`}
                initial={{ y: "115%" }}
                animate={show ? { y: "0%" } : { y: "115%" }}
                transition={{ duration: 1.1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}
